module.exports = __webpack_public_path__ + "th.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/th.svg
// module id = 1092
// module chunks = 0